import React , {useEffect, useState}from 'react';
import {Link, useHistory} from "react-router-dom";

import {useMenuList} from '../../../queries/menu';
import InfinitProgressBar from '../../InfiniteProgressBar';

function NavbarItem(props) {
    
    const {error, loading, data} = useMenuList();
    if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>
    return(
        data.menu[0].menuItemsList.contentItems.map(item=>(            
            <li key={item.id} style={{gap:'3%', padding:'1%'}} className={item.bag.contentItems || item.megaMenu ? 'has-submenu' : ''} >
                <Link style={{color: !props.isSided ? "black" : "white", direction:"ltr"}} to={`${process.env.PUBLIC_URL + item.linkMenuItem.url}`}>{item.displayText}</Link>
                {(() => {
                    if(item.bag.contentItems){                        
                        return(
                            <ul className="submenu-nav" >
                                {
                                    item.bag.contentItems.map((subItem,index)=>{
                                        return (
                                            <ul className="submenu-nav" >
                                                {
                                                    subItem.bag.contentItems.map((subItem,innerIndex)=>{
                                                        return <li style={{borderBottom: "1px solid rgba(255, 255, 255, .2)"}}  key={innerIndex}><Link  to={`${process.env.PUBLIC_URL + subItem.linkMenuItem.url}`}>{subItem.displayText}</Link></li>
                                                    })
                                                }
                                            </ul>
                                        )
                                    })
                                    
                                }
                            
                            </ul>
                        )
                    }

                    if(item.megaMenu){
                        return(
                            <div style={{backgroundColor: 'red'}}>
                                <ul className="submenu-nav submenu-nav-mega">
                                {
                                    item.bag.contentItems.map((megaItem, indx)=>(
                                        
                                        <li key={indx} className="mega-menu-item"><Link to={megaItem.linkMenuItem.url}>{megaItem.displayText}</Link>
                                            <ul>
                                                {
                                                    megaItem.bag.contentItems.map((subItem,index)=>{
                                                        return (
                                                            <ul>
                                                                {
                                                                    subItem.bag.contentItems.map((listItem,idx)=>{
                                                                        return <li key={idx}><Link to={`${process.env.PUBLIC_URL + listItem.linkMenuItem.url}`}>{listItem.displayText}</Link></li>
                                                                    })
                                                                }
                                                            </ul>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </li>
                                    ))
                                }
                            </ul>
                            </div>
                            
                        )
                    }
                })()}
            </li>
        ))
    )
}

export default NavbarItem